<template>
  <div class="details-view" :class="{sidebar: sidebar.opened}" style="overflow:unset; position:relative;">
    <div
      v-if="showSopIndex"
    >
      <div class="main-content">
        <div class="tip" :style="{ paddingBottom: advertisingLog ? '':'25px' }">
          <el-carousel v-show="advertisingLog" height="30px" style="width: auto;" direction="vertical" indicator-position="none" arrow="never" :interval="3000">
            <el-carousel-item v-for="item in advertisingData" :key="item.uuid">
              <span style="font-size: 16px;color: #ea8749" @click="doPage(item)">{{ item.order + '/' + advertisingData.length + ' ' }}</span>
              <span style="font-size: 16px;color: red" @click="doPage(item)">{{ item.subjectName + ' ' }}</span>
              <span style="font-size: 16px;color: #0C5ED9FF" @click="doPage(item)"> {{ item.title + ' ' }}</span>
              <span style="font-size: 16px;color: red" @click="doPage(item)">{{ item.content }}</span>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="section entry-container-wrapper">
          <span
            class="title"
          >{{ $t('Sop.QuickEntry') }}
            <el-popover
              placement="bottom"
              width="415"
              trigger="hover"
            >
              <div class="pop-content">{{ $t('Sop.QuickEntryPopover.FirstLine') }}</div>
              <div class="pop-content">{{ $t('Sop.QuickEntryPopover.SecondLine') }}</div>
              <svg-icon slot="reference" :icon-class="$store.state.settings.isUIPersonalized ? 'question-white' : 'question'" style="font-size: 14px;margin-top: -3px;" />
            </el-popover>
          </span>
          <div class="entry-expand" @click="handleUnfold">
            <span>{{ isUnfold ? $t('Sop.PackUp') : $t('Sop.Unfold') }}</span>
            <i v-if="!isUnfold" class="el-icon-arrow-down" />
            <i v-else class="el-icon-arrow-up" />
          </div>
          <div v-if="isUnfold" ref="entryDiv" class="entry-container-div" @drop="onDrop" @dragover="allowDrop">
            <div
              v-for="(entry, index) in finalEntry"
              :key="index"
              style="
              position: relative;
              display: flex;
              align-items: center;
              flex-direction: column;
            "
              @mouseover="currentFocusEntry = entry"
              @mouseleave="currentFocusEntry = null"
              @click.prevent="toLink(entry)"
            >
              <div class="entry-div">
                <!-- WC-1124 跑马灯和公告未读书接口优化 该小图标未用到，暂时注释掉  -->
                <!-- <svg-icon v-show="entry.enTitle === 'NoticeBoard' && unreadMessages" icon-class="gonggao" style="font-size: 20px;margin: 0;position: absolute;right:-5px;top:-5px;" />-->
                <div v-if="entry.enTitle === 'NoticeBoard' && unreadQuantity > 0" class="notice-unread">{{ unreadQuantity > 99 ?'99+':unreadQuantity }}</div>
                <template>
                  <img
                    v-if="entry.type == 'pin'"
                    :src="entry.icon"
                    style="display: block; height: 40px; margin: 12px 0;"
                  >
                  <img
                    v-else
                    :src="`${menuIconPath}${
                      entry.item.meta && entry.item.meta.parentIcon.replace('png','svg')
                    }`"
                    style="display: block; height: 40px; margin: 12px 0;"
                  >
                </template>

                <div
                  v-if="entry.type != 'pin'"
                  v-show="
                    entry.item.menuId ===
                      (currentFocusEntry &&
                        currentFocusEntry.item &&
                        currentFocusEntry.item.menuId)
                  "
                  style="position: absolute; top: -4px; right: -4px"
                  @click.stop="close(entry)"
                >
                  <i
                    style="color: #f96a6c; font-size: 16px; font-weight: bold"
                    class="el-icon-error"
                  />
                </div>
              </div>
              <div :style="{ color: '#333', width: $selectByLang('64px', '64px', '64px', '100px', '100px', '100px') }">
                {{ getTitle(entry) }}
              </div>
            </div>
          </div>
        </div>
        <div class="section sopWrapper" :class="{layer_height: showLayer}">
          <div class="board">
            <div v-if="$store.getters.enableFrontEndPlugin">
              <micro-app
                name="child-operation-date-query-sopboard"
                :url="$store.getters.frontEndPluginUrl+'/operationDateQuery'"
                router-mode="pure"
                destroy
                @datachange="operationDateQueryDataChange"
              />
            </div>
            <el-tabs v-model="activateTab" @tab-click="loadData(false)">
              <!--              <el-tab-pane v-if="pageIsActivated" key="sopBoard" name="sopBoard" :label="$t('CargoMsg.Cargo_SopBusinessFlowDashboard')">-->
              <!--                <span slot="label" style="font-size: 14px">-->
              <!--                  {{ $t('CargoMsg.Cargo_SopBusinessFlowDashboard') }}-->
              <!--                  <el-popover-->
              <!--                    placement="bottom"-->
              <!--                    width="437"-->
              <!--                    trigger="hover"-->
              <!--                  >-->
              <!--                    <div class="pop-content">{{ $t('Sop.SopBoardPopover.FirstLine') }}</div>-->
              <!--                    <div class="pop-content">-->
              <!--                      {{ $t('Sop.SopBoardPopover.SecondLine') }}-->
              <!--                    </div>-->
              <!--                    <div class="pop-content">{{ $t('Sop.SopBoardPopover.ThirdLine') }}</div>-->
              <!--                    <div class="pop-content">{{ $t('Sop.SopBoardPopover.FourthLine') }}</div>-->
              <!--                    <svg-icon slot="reference" :icon-class="$store.state.settings.isUIPersonalized ? 'question-white' : 'question'" style="font-size: 14px; margin-top: -3px; margin-right: 0" />-->
              <!--                  </el-popover>-->
              <!--                </span>-->
              <!--                <sop-board-->
              <!--                  ref="sopBoard"-->
              <!--                  :business-types="businessTypes"-->
              <!--                  :current-office-id="currentOfficeId"-->
              <!--                  :sop-node-data="sopNodeData"-->
              <!--                  :sop-node-query="sopNodeQuery"-->
              <!--                  :show-layer="showLayer"-->
              <!--                  :lob="lob"-->
              <!--                  @getActiveName="getActiveName"-->
              <!--                  @jumpSopNodeDetail="jumpSopNodeDetail"-->
              <!--                  @templateClick="onTemplateClick"-->
              <!--                  @templateChange="onTemplateChange"-->
              <!--                  @refresh="measureScrollbar"-->
              <!--                />-->
              <!--              </el-tab-pane>-->
              <!--              <el-tab-pane v-if="showSopWtDashBoard" key="sopWorkTaskBoard" name="sopWorkTaskBoard" :label="$t('CargoMsg.Cargo_SOPWorkTaskBoard')" lazy>-->
              <!--                <sop-work-task-board-->
              <!--                  ref="sopWorkTaskBoard"-->
              <!--                  :sop-work-task-board-lob="sopWorkTaskBoardLob"-->
              <!--                  :operation-date-query-search="operationDateQuerySearch"-->
              <!--                  :operation-date-query-column="operationDateQueryColumn"-->
              <!--                  @getActiveNameWt="getActiveNameWt"-->
              <!--                  @refreshTime="p => sopWorkTaskBoardRefreshTime = p"-->
              <!--                />-->
              <!--              </el-tab-pane>-->
              <!--              <el-tab-pane key="preWarning" name="preWarning" :label="$t('CargoMsg.Cargo_WarnTodoList')" lazy>-->
              <!--                &lt;!&ndash;              <div class="section preWarning-wrapper">&ndash;&gt;-->
              <!--                &lt;!&ndash;                <span class="title">{{ $t('Sop.toDoList') }}</span>&ndash;&gt;-->
              <!--                <pre-warning-->
              <!--                  ref="preWarning"-->
              <!--                  :pre-warning-lob="preWarningLob"-->
              <!--                  @getActiveNamePreWarning="getActiveNamePreWarning"-->
              <!--                />-->
              <!--                &lt;!&ndash;              </div>&ndash;&gt;-->
              <!--              </el-tab-pane>-->
              <!--              <el-tab-pane v-if="pageIsActivated" key="approvalMatters" name="approvalMatters" :label="$t('CargoMsg.Cargo_BpmTodoList')" lazy>-->
              <!--                &lt;!&ndash;              <span slot="label" style="font-size: 14px">{{ $t('CargoMsg.Cargo_BpmTodoList') }}&ndash;&gt;-->
              <!--                &lt;!&ndash;                <span v-if="approvalMatter.count > 0" style="color: #f56c6c; font-size: 14px">&ndash;&gt;-->
              <!--                &lt;!&ndash;                  {{ '(' + approvalMatter.count + ')' }}&ndash;&gt;-->
              <!--                &lt;!&ndash;                </span>&ndash;&gt;-->
              <!--                &lt;!&ndash;              </span>&ndash;&gt;-->
              <!--                <tab-approval-matters ref="approvalMatters" key="approvalMatters" type="approvalMatters" :approval-matter="approvalMatter" />-->
              <!--              </el-tab-pane>-->
              <el-tab-pane key="warningPending" name="warningPending" :label="$t('CargoMsg.Cargo_WarnTodoList')">
                <warning-pending ref="warningPending" :warning-modules="warningModules" />
              </el-tab-pane>
            </el-tabs>
            <el-button type="primary" class="btn" :style="{position: 'absolute', right: $selectByLang('130px', '160px', '150px', '200px', '140px', '120px'), top: '7px', cursor: 'pointer'}" @click="loadData(true)">
              {{ $t('CargoMsg.Cargo_LoadData') }}
            </el-button>
            <!--【刷新时间】-->
            <span style="position: absolute; right: 10px; top: 15px;" class="text">
              {{ $t('Sop.LastRefreshTime') + '  ' + finalRefreshTime }}
            </span>
            <!--            <span-->
            <!--              style="position: absolute; top: 17px;"-->
            <!--              class="text"-->
            <!--              :style="{right:activateTab==='sopBoard' ? $selectByLang('260px', '290px', '245px', '360px', '250px', '250px') : $selectByLang('205px', '265px', '225px', '340px', '220px', '220px')}"-->
            <!--            >-->
            <!--              {{ $t('Sop.LastRefreshTime') + '  ' + finalRefreshTime }}-->
            <!--            </span>-->
            <!--            <i-->
            <!--              v-if="activateTab==='sopBoard'"-->
            <!--              class="el-icon-setting text"-->
            <!--              :style="{position: 'absolute', right: $selectByLang('220px', '260px', '220px', '335px', '220px', '210px'), top: '12px', cursor: 'pointer', fontSize: '18px'}"-->
            <!--              @click="showSopSet"-->
            <!--            />-->
            <!--            &lt;!&ndash;刷新数据&ndash;&gt;-->
            <!--            <el-button-->
            <!--              type="primary"-->
            <!--              class="btn"-->
            <!--              :style="{position: 'absolute', right: $selectByLang('130px', '160px', '150px', '200px', '140px', '120px'), top: '7px', cursor: 'pointer'}"-->
            <!--              @click="loadData(true)"-->
            <!--            >-->
            <!--              {{ $t('CargoMsg.Cargo_LoadData') }}-->
            <!--            </el-button>-->
            <!--            &lt;!&ndash;设置成默认显示项&ndash;&gt;-->
            <!--            <el-button-->
            <!--              type="primary"-->
            <!--              class="btn"-->
            <!--              style="position: absolute; right: 10px; top: 7px;"-->
            <!--              @click="saveTabPersonConfig"-->
            <!--            >-->
            <!--              {{ $t('CargoMsg.Cargo_SetDefaultDisplayItem') }}-->
            <!--            </el-button>-->
          </div>
        </div>
        <div v-if="pageIsActivated" class="section preWarning-wrapper">
          <div class="three-days-logs" style="display: flex; justify-content: space-between; margin-bottom: 10px">
            <span class="title" style="margin-bottom:0px;align-self: center">{{ $t('CargoMsg.Cargo_ThreeDaysLogs') }}</span>
            <span v-if="$store.state.settings.isUIPersonalized" style="margin-right: 20px;align-self: center;color: #A5EBFF;text-decoration: underline;cursor: pointer;" @click="viewMoreLogs">{{ $t('CargoMsg.Cargo_ViewMoreLogs') }}</span>
            <el-button v-else style="margin-right: 20px;align-self: center" type="primary" @click="viewMoreLogs">{{ $t('CargoMsg.Cargo_ViewMoreLogs') }}</el-button>
          </div>
          <data-update-log style="height: 442px" source="HomePage" />
        </div>
      </div>

      <el-dialog
        :visible.sync="oweRemind.visible"
        class="owe-remind-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
        :show-close="false"
      >
        <!--      <div slot="title" style="height: 20px;" />-->
        <div
          :style="`background-image: ${oweRemind.background}`"
          class="owe-remind"
          @click.capture="messageClickHandler"
          v-html="oweRemind.content"
        />
        <img
          v-show="oweRemind.visibleCloseBtn"
          :src="close_3"
          style="
          cursor: pointer;
          position: absolute;
          bottom: 30px;
          right: 30px;
          width: 155px;
        "
          @click="oweRemind.visible = false"
        >
      </el-dialog>
      <el-dialog
        :visible.sync="msgNotifyVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
      >
        <div slot="title" style="height: 20px" />
        <div style="margin: 10px 20px">
          <div style="font-size: 20px; font-weight: bold; height: 50px">
            CargoWare基础版
          </div>
          <div style="color: orange; font-size: 16px; height: 30px">
            试用有效期剩余 {{ tryDays }} 天
          </div>
          <p style="line-height: 30px; font-size: 14px">
            <span
              style="color: red"
            >1、此环境仅用于试用，开通正式环境后，试用数据不会迁移到正式环境中。</span><br>
            2、试用到期后试用账号被锁定不可使用。<br>
            3、如决定购买请点击下方【立即购买】按钮，即可在线签约，在线支付，支付<br>
            成功后系统自动开通正式账号，马上使用。<br>
          </p>
        </div>
        <span slot="footer" style="display: flex; justify-content: center">
          <img :src="buy" style="width: 105px" @click="gotoBuy">
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="reminderVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
        center
      >
        <div slot="title" style="height: 20px">业务提醒</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="reminderVisible = false">关闭</el-button>
        </span>
      </el-dialog>
      <!-- :show-layer="showLayer" @handleColseMask="handleColseMask" -->
      <montmorill-layer v-if="pageIsActivated" :show-layer="showLayer" :scrollbar-width="scrollbarWidth" @handleColseMask="handleColseMask" />
    </div>
    <SopSetting v-else @closeSopSet="closeSopSet" />

    <!-- 更新通知 -->
    <el-dialog
      :visible.sync="showAnnContent.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :title="$t('Message.UpdateNoticeDetails')"
      @close="closeShowAnnContent"
    >
      <div class="dialog-anncontent" style="height: 400px;line-height:15px;overflow-y: auto">
        <el-input type="textarea" :readonly="true" v-html="showAnnContent.content" />
      </div>
      <span slot="footer">
        <el-checkbox v-show="showAnnContent.isAutoPop" v-model="showAnnContent.chkAuto" style="margin-right: 10px;">{{ $t('Message.DontRemindMeAgain') }}</el-checkbox>
        <el-button @click="closeShowAnnContent">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!--更新通知弹窗 -->
    <el-dialog
      :visible.sync="updateNotify.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      :title="$t('Message.UpdateNoticeDetails')"
    >
      <div class="dialog-anncontent" style="height: 400px;line-height:15px;overflow-y: auto">
        <el-input type="textarea" :readonly="true" v-html="updateNotify.content" />
      </div>
      <span slot="footer">
        <el-button @click="btnCloseUpdateNotify">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import oweRemind from '@/assets/notifyArrearage.png'
import {
  getPersonQueryConfig, queryModuleListFunc,
  savePersonQueryConfig
} from '@/api/commonComponent'
import { querySysBsDebtsNotify } from '@/api/user'
import {
  getWeeklyJobQuantity,
  getSopNodeInfo,
  getSopNodeInfoByTemplate,
  getLobTemplateAndNodeCount
} from '@/api/sop'
import { getLoading } from '@/utils/utilBaseElement'
import deskbg_100 from '@/assets/deskbg_100.jpg'
import deskbg from '@/assets/deskbg.jpg'
import ubi_desk_logo1 from '@/assets/logo/ubi_desk_logo1.png'
import ubi_desk_logo_3 from '@/assets/logo/ubi_desk_logo_3.png'

import buy from '@/assets/buy.png'
import close_3 from '@/assets/close_3.png'

import { getConfig, cacheName, cache } from '@/utils/cacheManager'
import DateUtils from '@/utils/dateUtils'
import { getCargoJumpUrl } from '@/utils/permission'
import SopBoard from './components/SopBoard'
import LineChart from './components/LineChart'
import MontmorillLayer from './components/MontmorillLayer'
import { formatHourMinute } from '@/utils/index'
import SopSetting from './components/SopSetting/index'
import checkPermission from '@/utils/permission'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { loadAnnouncement } from '@/api/announcement'
import settings from '@/settings'
import PreWarning from '@/views/dashboard/admin/components/PreWarning'
import { getAdvertisingDataFunc, insertDataLogFunc } from '@/api/sysManage/advertisingConfig'
import { getLangMetaTitle } from '@/utils/langUtil'
import { updateTrackingTemplateUuids } from '@/api/user'
import DataUpdateLog from '@/views/cargo/v0/SystemMonitor/dataUpdateLog'
import { sendMenuClickLogBuriedPoints } from '@/api/menu'
import SopWorkTaskBoard from '@/views/dashboard/admin/components/SopWorkTaskBoard'
import TabApprovalMatters from '@/views/dashboard/admin/components/PreWarning/components/tabApprovalMatters'
import { getUserInfo } from '@/utils/auth'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import microApp from '@micro-zoe/micro-app'
import WarningPending from '@/views/dashboard/admin/components/WarningPending'

// 页面缓存信息
const pageCache = {
  sopWorkTaskBoardLob: '',
  preWarningLob: '',
  activateTab: ''
}

export default {
  name: 'DashboardAdmin',
  components: {
    WarningPending,
    PreWarning,
    SopBoard,
    LineChart,
    MontmorillLayer,
    SopSetting,
    DataUpdateLog,
    SopWorkTaskBoard,
    TabApprovalMatters
  },
  props: {
    // scrollbarWidth: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    const menuIconPath = this.$store.state.settings.isUIPersonalized ? '/static/deepBlueMenu/' : '/static/menu/'
    return {
      menuIconPath,
      deskbg_100,
      deskbg,
      ubi_desk_logo1,
      ubi_desk_logo_3,
      close_3,
      buy,
      unreadQuantity: 0,
      showJobTypes: [], // 展示业务编号
      wtOpenConfig: false, // 是否开启沃联功能
      wtPageUrl: null, // 沃联页面地址
      advertisingLog: false, // 是否创建浏览记录
      advertisingData: [], // 广告列表
      currentFocusEntry: null,
      msgNotifyVisible: false,
      loading: false,
      oweRemind: {
        visibleCloseBtn: false,
        visible: false,
        background: 'url(' + oweRemind + ')',
        content: '<h1>欠费了</h1>'
      },
      basicTry: {
        // 基础班试用提醒
        visible: true
      },
      pinnedEntryListFor100: [],
      pinnedEntry: {
        platform: [
          {
            icon: menuIconPath + 'announcement_title_1.svg',
            title: '更新通知',
            enTitle: 'System Notification',
            jaTitle: 'お知らせ',
            ruTitle: 'Обновить уведомление',
            thTitle: 'ประกาศการปรับปรุง',
            viTitle: 'Thông báo cập nhật',
            type: 'pin',
            callback: this.toLinkUpdateNotify
          },
          {
            icon: menuIconPath + 'task_title_1.svg',
            title: '业务提醒',
            enTitle: 'Task Reminders',
            jaTitle: '業務通知',
            ruTitle: 'Оперативные напоминания',
            thTitle: 'การแจ้งเตือนทางธุรกิจ',
            viTitle: 'Nhắc nhở về công việc',
            type: 'pin',
            callback: this.toLinkBusinessWarn
          },
          {
            icon: menuIconPath + 'price_sel.svg',
            title: '运价查询',
            enTitle: 'Rate List',
            jaTitle: '運賃一覧',
            ruTitle: 'Тарифный запрос',
            thTitle: 'สอบถามราคาค่าขนส่ง',
            viTitle: 'Tìm kiếm giá',
            type: 'pin',
            callback: this.toLinkPriceSee
          }
        ],
        ubi: [
          {
            icon: '/static/menu/announcement_title_1.svg',
            title: '更新通知',
            enTitle: 'System Notification',
            type: 'pin',
            callback: this.toLinkUpdateNotify
          },
          {
            icon: '/static/menu/task_title_1.svg',
            title: '业务提醒',
            enTitle: 'Task Reminders',
            type: 'pin',
            callback: this.toLinkBusinessWarn
          },
          {
            icon: '/static/menu/price_sel.svg',
            title: '运价查询',
            enTitle: 'Rate List',
            type: 'pin',
            callback: this.toLinkPriceSee
          }
        ]
      },
      entryList: [],
      entryConfig: {
        configName: '快速入口配置',
        bDefault: true,
        configModule: 100,
        configType: 3 // 固定值，快捷入口配置
      },
      businessTypes: [
        { label: this.$t('Sop.SeaExport'), name: 'SE', popVisible: false },
        { label: this.$t('Sop.SeaImport'), name: 'SI', popVisible: false },
        { label: this.$t('Sop.AirExport'), name: 'AE', popVisible: false },
        { label: this.$t('Sop.AirImport'), name: 'AI', popVisible: false },
        { label: this.$t('Sop.RailwayExport'), name: 'RE', popVisible: false },
        { label: this.$t('Sop.RailwayImport'), name: 'RI', popVisible: false },
        { label: this.$t('Sop.IntegratedJob'), name: 'IE', popVisible: false }
      ],
      chartData: {
        xAxisData: [],
        SE: [],
        SI: [],
        AE: [],
        AI: [],
        RE: [],
        IE: []
      },
      reminderVisible: false,
      showLayer: false, // 显示蒙层
      refreshTime: formatHourMinute(new Date()), // sop面板刷新时间
      sopWorkTaskBoardRefreshTime: formatHourMinute(new Date()), // sop工作任务面板刷新时间
      otherRefreshTime: formatHourMinute(new Date()), // 其他面板刷新时间
      showSopIndex: true,
      pageIsActivated: true, // 当前页签是否已激活
      isUnfold: true,
      autoTimer: null,
      time: 600000, // 自动刷新
      unreadMessages: false,
      sopNodeData: {
        'SE': { templates: [], sopNodeJobStatistics: [] },
        'SI': { templates: [], sopNodeJobStatistics: [] },
        'AE': { templates: [], sopNodeJobStatistics: [] },
        'AI': { templates: [], sopNodeJobStatistics: [] },
        'RE': { templates: [], sopNodeJobStatistics: [] },
        'RI': { templates: [], sopNodeJobStatistics: [] },
        'IE': { templates: [], sopNodeJobStatistics: [] }
      }, // sop面板节点数据
      lob: '', // sop面板类型标签
      sopWorkTaskBoardLob: '', // sop工作任务面板类型标签
      preWarningLob: '', // 预警面板类型标签
      timer: null,
      sopNodeQuery: {},
      sopLayerStyle: {},
      status: true,
      sopLoading: null,
      fakeFlag: false,
      hideSopLoading: false,
      scrollbarWidth: 0,
      announcements: [],
      showAnnContent: {
        visible: false,
        chkAuto: false,
        isAutoPop: false,
        content: ''
      },
      activateTab: 'warningPending',
      approvalMatter: {
        count: 0
      },
      showSopWtDashBoard: false,
      updateNotify: {
        visible: false,
        content: ''
      },
      preWarningSettingEnable: false, // 是否有使用【预警待办事项列表设置】
      operationDateQuery: { // 操作日期查询条件、显示列
        viewSource: 'SopBoard',
        searchItem: false, // 查询条件
        columnItem: false // 显示列
      },
      operationDateQuerySearch: false,
      operationDateQueryColumn: false,
      warningModules: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUserConfig',
      'showedOweRemind',
      'userId',
      'currentDeptId',
      'language',
      'isAdmin',
      'tenantId',
      'userInfo',
      'currentOfficeId',
      'sidebar'
    ]),
    routes() {
      return this.$store.state.permission.routes
    },
    maxCount() {
      // return this.ubi ? 6 : 12
      return 12
    },
    ubi() {
      return this.tenantId === 100
    },
    // 深圳丰收销售专用
    isSalesForSzFs() {
      return String(cache.config.get('ToExoSystem')) === 'SZFS' && !this.$store.getters.isAdmin &&
        (this.$checkPermission(['role_salesOfGoods']) || this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) ||
          this.$checkPermission(['role_platform_sales']) || this.$checkPermission(['role_branchSales']) || this.$checkPermission(['role_sales']))
    },
    pinnedEntryList() {
      if (!this.isSalesForSzFs) {
        const self = this
      }
      return this.pinnedEntry.platform
    },
    tryDays() {
      // console.log('this.userInfo', this.userInfo, this.userInfo.expiredDate, this.userInfo.expired, this.userInfo.expirationDate)
      return DateUtils.getBetweenDays(new Date(), this.userInfo.expirationDate)
    },
    finalEntry() {
      return this.pinnedEntryList.concat(this.entryList)
    },
    dashboardAdminContainerStyle() {
      const { ubi, deskbg_100, deskbg } = this
      return {
        background: 'url(' + (ubi ? deskbg_100 : deskbg) + ')',
        'background-size': '100% 100%',
        height: '100%;',
        'background-repeat': 'no-repeat'
      }
    },
    entryContainerDivStyle() {
      const { ubi } = this
      return {
        width: ubi ? '100%' : '800px',
        height: ubi ? '200px' : '500px',
        'justify-content': ubi ? 'center' : 'flex-start'
      }
    },
    finalRefreshTime() {
      if (this.activateTab === 'sopBoard') {
        return this.refreshTime
      }
      if (this.activateTab === 'sopWorkTaskBoard') {
        return this.sopWorkTaskBoardRefreshTime
      }
      return this.otherRefreshTime
    }
  },
  watch: {
    // 检测到tab栏变化时，soploading为null
    lob(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.sopLoading = null
        this.fetchNodeInfo()
        // this.getAdvertisingConfig(true)
      }
    },
    currentOfficeId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // 初始化配置
        this.initCache()
        this.refreshPage()
        this.getWtPageUrl()
      }
    }
  },

  beforeMount() {
  },
  created() {
  },
  async mounted() {
  },
  async activated() {
    this.showSopIndex = true
    this.pageIsActivated = true
    this.preWarningSettingEnable = false
    const preWarningSetting = LocalStorageUtilsNew.getConfiguration('preWarning-setting')
    if (preWarningSetting) {
      for (const key in preWarningSetting) {
        if (preWarningSetting[key]) {
          this.preWarningSettingEnable = true
          break
        }
      }
    }
    // 原created中代码
    const sopGuide = localStorage.getItem(`sopGuide${this.userInfo.userId}`) || true
    this.showLayer = sopGuide === true
    this.initCache()
    // 原beforeMount中代码
    if (
      this.currentUserConfig.entries &&
      this.currentUserConfig.entries.length
    ) {
      this.entryList = this.currentUserConfig.entries
      // 更新快捷入口信息
      for (const entry of this.entryList) {
        const menu = this.getMenu(entry.item.menuId)
        if (menu) {
          for (const key in entry.item) {
            entry.item[key] = menu[key]
          }
        }
      }
    } else {
      this.init()
    }
    // 原mounted中代码
    await this.loadTabPersonConfig() // 加载首页看板tab默认值配置
    this.refreshPage() // 首次进入页面请求接口数据
    this.autoRefresh() // 10分钟自动刷新页面
    window.addEventListener('resize', this.measureScrollbar)
    this.$nextTick(() => {
      if (!this.$store.getters.userInfo.firstLogin) {
        this.showAnnouncement() // 更新公告
      }
    })
    const div = document.getElementById('BillPaymentWorkFlowApplyDialog') // 查看是否最小化了付款申请单及查看审批流程的弹窗，有打开，则每次进入到首页，都将tab切换到审批事项列表
    this.$store.commit('APPROVE_DIALOG_SHOW', '')
    if (div) {
      this.$store.commit('APPROVE_DIALOG_SHOW', true)
      this.activateTab = 'approvalMatters'
    } else {
      this.$store.commit('APPROVE_DIALOG_SHOW', false)
    }
  },
  deactivated() {
    this.pageIsActivated = false
    // 原beforeDestroy中代码
    if (this.activateTab === 'sopWorkTaskBoard') {
      pageCache.sopWorkTaskBoardLob = this.sopWorkTaskBoardLob
      pageCache.preWarningLob = ''
      pageCache.activateTab = this.activateTab
    } else if (this.activateTab === 'preWarning') {
      pageCache.sopWorkTaskBoardLob = ''
      pageCache.preWarningLob = this.preWarningLob
      pageCache.activateTab = this.activateTab
    } else if (this.activateTab === 'warningPending') {
      pageCache.sopWorkTaskBoardLob = ''
      pageCache.preWarningLob = ''
      pageCache.activateTab = this.activateTab
    } else {
      pageCache.sopWorkTaskBoardLob = ''
      pageCache.preWarningLob = ''
      pageCache.activateTab = ''
    }
    if (this.$refs.sopWorkTaskBoard) {
      this.$refs.sopWorkTaskBoard.beforeDestroy()
    }
    if (this.autoTimer) {
      clearInterval(this.autoTimer)
      this.autoTimer = null
    }
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  beforeDestroy() {
  },
  methods: {
    async initCache() {
      await cache.load(cacheName.CONFIG)
      const dashboardShowJobType = cache.config.get('dashboardShowJobType')
      this.showJobTypes = !dashboardShowJobType || dashboardShowJobType.trim() === '' ? [] : dashboardShowJobType.split(',')
    },
    // 获取滚动条宽度
    measureScrollbar() {
      const outer = document.createElement('div')
      outer.style.visibility = 'hidden'
      outer.style.width = '100px'
      outer.style.position = 'absolute'
      outer.style.top = '-9999px'
      document.body.appendChild(outer)
      try {
        const widthNoScroll = outer.offsetWidth // 获取没有滚动条的元素宽度
        outer.style.overflow = 'hidden' // 强制滚动条
        const inner = document.createElement('div') // 内部创建元素
        inner.style.width = '100%'
        outer.appendChild(inner)
        const widthWithScroll = inner.offsetWidth // 获取内部元素的可视区域，有滚动条

        // Some pages don't render .app-main-content; avoid throwing and breaking rendering.
        const appSrcoll = document.getElementsByClassName('app-main-content')[0]
        if (!appSrcoll) {
          this.scrollbarWidth = widthNoScroll - widthWithScroll
          return
        }
        const appSrcollWidth = appSrcoll.offsetWidth - appSrcoll.clientWidth
        this.scrollbarWidth = widthNoScroll - widthWithScroll + appSrcollWidth // 获取
      } finally {
        if (outer && outer.parentNode) {
          outer.parentNode.removeChild(outer) // 移除创建的节点
        }
      }
    },
    // 获取一周业务曲线
    async fetchWeeklyJobQuantity() {
      const params = { branchId: this.currentOfficeId }
      const res = await getWeeklyJobQuantity(params).finally((e) => {
        if (this.loading) {
          this.loading.close()
        }
      })
      const tmp = {}
      const data = res.data
      // 对后台返回的数据格式进行处理
      data.map(item => {
        if (!tmp[item.lob]) {
          tmp[item.lob] = []
        }
        tmp[item.lob].push(item.quantity)
      })
      let xAxisData = data.map((item) => {
        return item.date
      })
      xAxisData = Array.from(new Set(xAxisData))
      tmp['xAxisData'] = xAxisData
      this.chartData = tmp
      console.log('chartData', this.chartData)
    },
    getActiveName(activeName) {
      this.lob = activeName
    },
    getActiveNameWt(activeName) {
      this.sopWorkTaskBoardLob = activeName
    },
    getActiveNamePreWarning(activeName) {
      this.preWarningLob = activeName
    },
    async fetchNodeInfo(showLoading = false) {
      const lob = this.lob
      const data = {
        branchId: this.currentOfficeId,
        lob
      }
      const loading = showLoading ? getLoading() : null
      try {
        const res = await getSopNodeInfo(data)
        const { status, jobState, etdStart, etdEnd } = res
        this.status = status
        // const status = false
        this.sopNodeQuery = {
          jobState,
          etdStart,
          etdEnd
        }
        res.data.sopNodeJobStatistics.forEach((item) => {
          item.copyName = this.$store.getters.isZh ? item.name : item.eName
          item.name = item.name.length > 7 ? item.name.slice(0, 7) + '...' : item.name
          item.eName = item.eName.length > 12 ? item.eName.slice(0, 12) + '...' : item.eName
        })
        const resdata = {
          templates:
            res.data.templates.map(item => {
              for (const businessType of this.businessTypes) {
                if (businessType.name === lob) {
                  if (businessType.templateNodeCountInfo) {
                    item.nodeCount = businessType.templateNodeCountInfo[item.uuid] || 0
                  }
                  break
                }
              }
              return item
            }).filter(item => item.nodeCount > 0),
          sopNodeJobStatistics:
            res.data.sopNodeJobStatistics.map(item => {
              item.disabled = item.subNodes.every(item1 => {
                return item1.count === '0'
              })
              item.subNodes.forEach((item1) => {
                const subNameLen = item1.subName.length
                item1.subName = subNameLen > 10 ? item1.subName.slice(0, 10) + '...' : item1.subName
              })
              return item
            })
        }
        if (this.sopNodeData[lob].templates.length === 0) {
          this.sopNodeData[lob] = resdata
        }
        if (!status) {
          if (!this.sopLoading && !this.hideSopLoading) {
            this.sopLoading = getLoading('sopWrapper')
          }
          if (showLoading) {
            await sleep(5000)
            this.timer = setTimeout(() => {
              this.fetchNodeInfo(showLoading)
            }, 1)
            return
          } else {
            this.timer = setTimeout(() => {
              this.fetchNodeInfo()
            }, 5000)
          }
          // this.setSopLayer()
        } else {
          this.sopNodeData[lob] = resdata
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.$nextTick(() => {
            this.sopLoading && this.sopLoading.close()
          })
          this.hideSopLoading = true
        }
      } finally {
        if (loading) {
          loading.close()
        }
      }
      this.$nextTick(() => {
        this.$refs.sopBoard && this.$refs.sopBoard.__resizeHandler()
      })
      this.measureScrollbar()
    },
    messageClickHandler() {
      const sessionId = this.userInfo.sessionId
      const url = `${process.env.VUE_APP_CARGO}/ForwardServlet?sessionId=${sessionId}&target=BS`
      window.open(url, '_blank')
    },
    async trialEnvironment() {
      const config = await getConfig(1, false)
      this.msgNotifyVisible =
        !this.isAdmin &&
        Number(config.get('trialEnvironment')) === this.tenantId
    },
    async getWtPageUrl() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.wtPageUrl = cache.config.get('wtPagePostUrl')
      this.wtOpenConfig = parseInt(cache.config.get('wtOpenConfig')) === 1
    },
    doPage(item) {
      // 保存浏览广告记录
      this.insertView(0, item)
      console.log(item.pageUrl)
      if (item.pageUrl) {
        window.open(item.pageUrl, '_blank')
      }
    },
    baseData() {
      return { page: 'index', module: 'index', systemSource: 'cargoWare' }
    },
    // 广告位配置查询
    async getAdvertisingConfig(view) {
      await this.getWtPageUrl()
      if (!this.wtOpenConfig) {
        console.log('沃联开关未开启')
        return
      }
      const query = this.baseData()
      await getAdvertisingDataFunc(query).then(res => {
        if (res.data && res.data.length > 0) {
          this.advertisingData = res.data
          this.advertisingLog = true
        } else {
          this.advertisingData = []
          this.advertisingLog = false
        }
        // 保存浏览广告记录
        if (view) {
          this.insertView(1, null)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 保存浏览记录
    async insertView(view, item) {
      if (this.advertisingLog) {
        const log = this.baseData()
        log.view = view
        log.click = !view
        log.advertisingConfigs = this.advertisingData
        log.userType = '1'
        if (log.click) {
          log.advertisingConfigs = [item]
        }
        insertDataLogFunc(log)
      }
    },
    async gotoBuy() {
    },
    async init() {
      this.loading = getLoading()
      await this.getConfigEntries()
      await this.trialEnvironment()
      await this.getWtPageUrl()

      if (!this.showedOweRemind) {
        this.$store.dispatch('app/setShowedOweRemind', true)
        // 查询计费系统弹框信息通知
        await querySysBsDebtsNotify()
          .then((res) => {
            if (res.data[0]) {
              this.oweRemind.visible = true
              this.oweRemind.visibleCloseBtn = !res.data[0].BLOCKED
              this.oweRemind.content = res.data[0].NOTIFY_CONTENT
            }
          })
          .finally((f) => {
            if (this.loading) {
              this.loading.close()
            }
          })
      } else {
        if (this.loading) {
          this.loading.close()
        }
      }
    },
    close(entry) {
      // console.log('close====')
      if (entry.item.menuId === undefined) {
        return
      }
      this.entryList = this.entryList.filter((e) => {
        // console.log('item.menuId != entry.item.menuId', e.item.menuId, e.item.menuId)
        return e.type === 'pin' || e.item.menuId !== entry.item.menuId
      })
      this.$store.dispatch('user/setConfigOptEntries', this.entryList)
      savePersonQueryConfig({
        ...this.entryConfig,
        configContent: JSON.stringify(this.entryList)
      })
        .then((res) => {
          console.log('删除快速入口状态成功')
        })
        .catch((err) => {
          console.log('删除快速入口状态失败')
          console.log(err)
        })
    },
    // 更新通知
    toLinkUpdateNotify() {
      this.updateNotify.visible = true
      const loading = getLoading()
      loadAnnouncement().then((res) => {
        if (res.data && res.data.length > 0) {
          // 取发布时间最新且状态有效的数据
          const invalidArr = res.data.filter(item => item.invalid === true && item.newsDate)
          if (invalidArr) {
            const sortedDataArr = invalidArr.sort((a, b) => b.newsDate - a.newsDate)
            if (sortedDataArr) {
              this.updateNotify.content = sortedDataArr[0].content
            }
          }
        }
      }).catch((err) => {
        console.log(' 查询更新公告数据失败 ')
        console.log(err)
        this.updateNotify.visible = false
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    // 关闭更新通知
    btnCloseUpdateNotify() {
      this.updateNotify.visible = false
    },
    toLinkCargo(path) {
      window.open(path, '_blank')
    },
    // 业务提醒
    toLinkBusinessWarn() {
      // todo-shengsheng  Desc: nothing
      if (!checkPermission(['button_BusinessReminder'])) {
        this.$message.warning(this.$t('Sop.hasPermission'))
        return
      }
      this.showReminderDialog()
    },
    // 运价查询
    toLinkPriceSee() {
      // todo-shengsheng  Desc: 跳转到运价查询路由
      if (!checkPermission(['button_FreightInquiry'])) {
        this.$message.warning(this.$t('Sop.hasPermission'))
        return
      }
      const priceRoutes = this.routes.find(item => item.module === 'Freight Rate')
      if (!priceRoutes) {
        this.$message.warning(this.$t('Sop.hasPermission'))
        return
      }
      const PRPriceReal = priceRoutes.children.find(item => item.module === 'PRPriceReal')
      if (!PRPriceReal) {
        return
      }
      if (PRPriceReal.jumpCargo) {
        const jumpCargoUrl = getCargoJumpUrl({
          code: 'PRPriceReal',
          language: this.language,
          sessionId: this.userInfo.sessionId,
          branchId: this.currentOfficeId,
          departmentId: this.currentDeptId
        })
        this.toLinkCargo(jumpCargoUrl)
      } else {
        this.$router.push({ name: PRPriceReal.name })
      }
    },
    // sop看板点击子节点跳转相应的页面
    async jumpSopNodeDetail(data) {
      const templateKey = this.$refs.sopBoard ? this.$refs.sopBoard.templateKey || '' : ''
      let currentRoutes = null
      let childRoutes = ''
      // let routeName = ''
      const { sopCode, sopSubCode, name, subName, newSubNodes } = data
      const { etdStart } = this.sopNodeQuery
      let jobState = this.sopNodeQuery.jobState
      if (jobState) {
        let arr = jobState.split(',')
        arr = arr.filter(state => state > -1)
        jobState = arr.join(',')
      }
      // etdStart = etdStart.replace(/ /g, '%20')
      // etdEnd = etdEnd.replace(/ /g, '%20')
      switch (this.lob) {
        case 'SE':
          currentRoutes = this.routes.find(item => item.module === 'SEAEXPORT')
          childRoutes = 'fmBookingNew'
          break
        case 'SI':
          currentRoutes = this.routes.find(item => item.module === 'SEAIMPORT')
          childRoutes = 'SIBOOKING'
          break
        case 'AE':
          currentRoutes = this.routes.find(item => item.module === 'AIREXPORT')
          childRoutes = 'AEBooking'
          break
        case 'AI':
          currentRoutes = this.routes.find(item => item.module === 'AIRIMPORT')
          childRoutes = 'AIBooking'
          break
        case 'RE':
          currentRoutes = this.routes.find(item => item.module === 'RAILWAYEXPORT')
          childRoutes = 'RailwayExport'
          break
        case 'RI':
          currentRoutes = this.routes.find(item => item.module === 'RAILWAYEXPORT')
          childRoutes = 'RailwayExport'
          break
        case 'IE':
          currentRoutes = this.routes.find(item => item.module === 'IEBooking')
          childRoutes = 'IEBooking'
          break
      }
      if (!currentRoutes) {
        return
      }
      console.log(currentRoutes)
      const currntChildRoute = currentRoutes.children.find(item => item.module === childRoutes)
      if (!currntChildRoute) {
        return
      }
      if (await this.isJumpCargo(currntChildRoute)) {
        const jumpCargoUrl = getCargoJumpUrl({
          code: currntChildRoute.module,
          language: this.language,
          sessionId: this.userInfo.sessionId,
          branchId: this.currentOfficeId,
          departmentId: this.currentDeptId,
          lob: this.lob,
          sopCode,
          sopSubCode,
          etdStart,
          jobState
        })
        this.toLinkCargo(jumpCargoUrl)
      } else {
        if (currntChildRoute && currntChildRoute.meta) {
          currntChildRoute.meta.showExtraParam = true
        }
        this.$router.push({
          name: currntChildRoute.name,
          params: { code: sopCode, subCode: sopSubCode, name, subName, newSubNodes, jobState, etdStart, lob: this.lob, 'templateKey': templateKey }
        })
      }
    },
    // 获取菜单
    getMenu(menuId, routes = null) {
      if (!routes) {
        routes = this.$store.getters.permission_routes
      }
      for (const route of routes) {
        if (route.menuId === menuId) {
          return route
        }
        if (route.children) {
          const menu = this.getMenu(menuId, route.children)
          if (menu) {
            return menu
          }
        }
      }
      return null
    },
    async toLink(e) {
      try {
        if (e.title) {
          sendMenuClickLogBuriedPoints({ menu: '快捷入口', point: e.title })
        }
      } catch (e) {
        //
      }
      if (e.type === 'pin') {
        if (e.callback) {
          e.callback()
        }
        return
      }
      if (await this.isJumpCargo(e.item)) {
        // 未开发功能，需跳转flex-cargo
        // `${process.env.VUE_APP_CARGO}/ssoForward?sessionId=${this.userInfo.sessionId}&branchId=${this.currentOfficeId}&language=zh&module=${e.item.code}&reportId=${e.item.reportId}`
        const jumpCargoUrl = getCargoJumpUrl({
          code: e.item.module,
          language: this.language,
          sessionId: this.userInfo.sessionId,
          branchId: this.currentOfficeId,
          departmentId: this.currentDeptId
        })
        this.toLinkCargo(jumpCargoUrl)
        return
      }
      if (!e.item.name) {
        this.$alert('请配置正确的路由名称', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.$router.push({ name: e.item.name })
    },
    // 是否跳转cargo
    async isJumpCargo(item) {
      let user = null
      let tenantOfficeMenus = null
      let officeUuid = ''
      await ensureExecuteSuccess(() => {
        if (!this.$store.state.user) {
          return false
        }
        user = this.$store.state.user
        if (!user.menuInfo || !user.menuInfo.tenantOfficeMenus) {
          return false
        }
        tenantOfficeMenus = user.menuInfo.tenantOfficeMenus
        if (!this.$store.getters.currentOfficeUuid) {
          return false
        }
        officeUuid = this.$store.getters.currentOfficeUuid
        return true
      })
      // 根据当前分公司判断菜单是否开启跳转H5功能
      for (const tenantOfficeMenu of tenantOfficeMenus) {
        if (item.uuid && item.uuid === tenantOfficeMenu.menuUuid && officeUuid && officeUuid === tenantOfficeMenu.officeUuid) {
          return !tenantOfficeMenu.openH5Url
        }
      }
      return item.jumpCargo
    },
    onDrop(ev) {
      ev.preventDefault()
      const data = JSON.parse(ev.dataTransfer.getData('text'))
      console.log('data', data)
      data.item.children = null // 剔除子节点，避免信息过多
      const find = this.entryList.find((e) => {
        return e.item.menuId === data.item.menuId
      })
      if (find) {
        this.$alert('亲，模块已存在哦O(∩_∩)O哈哈~', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      if (this.entryList.length >= this.maxCount) {
        this.$alert('亲，面板已满哦O(∩_∩)O哈哈~请移除其他在添加.', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.entryList.push(data)
      this.$store.dispatch('user/setConfigOptEntries', this.entryList)
      savePersonQueryConfig({
        ...this.entryConfig,
        configContent: JSON.stringify(this.entryList)
      })
        .then((res) => {
          console.log('保存快速入口状态成功')
        })
        .catch((err) => {
          console.log('保存快速入口状态失败')
          console.log(err)
        })
    },
    async getConfigEntries() {
      const perConfig = {
        ...this.entryConfig,
        configBy: this.userId,
        tenantId: this.tenantId
      }
      await getPersonQueryConfig(perConfig)
        .then((res) => {
          if (res.data.length > 0) {
            const { configContent } = res.data[0]
            const entryList = configContent ? JSON.parse(configContent) : []
            this.entryList = entryList
            for (const entry of this.entryList) {
              const menu = this.getMenu(entry.item.menuId)
              if (menu) {
                for (const key in entry.item) {
                  entry.item[key] = menu[key]
                }
              }
            }
            this.$store.dispatch('user/setConfigOptEntries', entryList)
          }
        })
        .catch((err) => {
          // 没有配置
          console.log(err)
        })
    },
    allowDrop(ev) {
      ev.preventDefault()
    },
    handleSetLineChartData(type) {
      // this.lineChartData = lineChartData[type]
      console.log('do nothing', type)
    },
    getTitle(entry) {
      return getLangMetaTitle(entry)
    },
    showReminderDialog() {
      this.reminderVisible = true
    },
    handleColseMask() {
      this.showLayer = false
    },
    // 关闭设置页面
    closeSopSet() {
      this.showSopIndex = true
      this.hideSopLoading = false
      this.sopLoading = null
      this.handleRefreshPage()
    },
    handleRefreshPage() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer)
        this.autoTimer = null
      }
      this.refreshPage()
    },
    async sopBoardCount() {
      const businessTypes = [
        { label: this.$t('Sop.SeaExport'), name: 'SE' },
        { label: this.$t('Sop.SeaImport'), name: 'SI' },
        { label: this.$t('Sop.AirExport'), name: 'AE' },
        { label: this.$t('Sop.AirImport'), name: 'AI' },
        { label: this.$t('Sop.RailwayExport'), name: 'RE' },
        { label: this.$t('Sop.RailwayImport'), name: 'RI' },
        { label: this.$t('Sop.IntegratedJob'), name: 'IE' }
      ]
      const res = await getLobTemplateAndNodeCount({ branchId: this.currentOfficeId }).finally((e) => {
        if (this.loading) {
          this.loading.close()
        }
      })
      const data = res.data
      const newdata = []
      for (const businessType of businessTypes) {
        const item = data[businessType.name]
        if (!item) {
          continue
        }
        const obj = { ...businessType, count: Object.values(item).filter(p => p > 0).length, popVisible: false, templateNodeCountInfo: item }
        newdata.push(obj)
      }
      this.businessTypes = this.showTab(newdata)
      if (this.lob) {
        if (this.businessTypes && this.businessTypes.length > 0) {
          const businessTypes = this.businessTypes.filter(item => item.name === this.lob)
          if (!businessTypes || businessTypes.length === 0) {
            // 配置中的业务 不在 可见列表中，则随机取一个
            this.lob = this.businessTypes[0].name
          }
        } else {
          this.lob = null
        }
      } else {
        this.lob = this.businessTypes[0].name
      }
      this.fetchNodeInfo()
    },
    refreshPage() {
      this.refreshTime = formatHourMinute(new Date())
      // this.init()
      // this.fetchWeeklyJobQuantity()
      // this.fetchNodeInfo(this.lob)
      // this.sopBoardCount()
    },
    // 显示首页设置页面
    showSopSet() {
      this.showSopIndex = false
    },
    // 快捷入口展开与收起
    handleUnfold() {
      this.isUnfold = !this.isUnfold
    },
    autoRefresh() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer)
        this.autoTimer = null
      } else {
        this.autoTimer = window.setInterval(() => {
          setTimeout(() => {
            this.refreshPage()
            // this.getAdvertisingConfig(false)
          }, 0)
        }, this.time)
      }
    },
    // 更新公告
    showAnnouncement() {
      // 开关关闭时不自动弹出更新通知公告弹窗（settings.showUpdateAnnouncement 默认 false）
      if (!settings.showUpdateAnnouncement) return
      loadAnnouncement().then((res) => {
        this.announcements = res.data
        if (this.announcements && this.announcements.length > 0) {
          const announcement = this.announcements[0]
          // 不判断版本号，改成判断是否失效
          const key = this.$store.getters.tenantId + '_' + this.$store.getters.userId + '_' + announcement.releaseVersion
          const isAutoPop = JSON.parse(localStorage.getItem(key))
          const vistedViews = this.$store.state.tagsView.visitedViewsStack
          if (this.$store.getters.tenantId > 1 && !isAutoPop && announcement.invalid && vistedViews.length === 1) {
            this.popUpAnnouncementWindow(announcement.content, true, announcement.releaseVersion)
          }
        }
      })
    },
    // 更新公告-详细通知
    popUpAnnouncementWindow(content, isAutoPop, releaseVersion = null) {
      this.showAnnContent.releaseVersion = releaseVersion
      this.showAnnContent.isAutoPop = isAutoPop
      this.showAnnContent.content = this.replaceAll(content, '${sessionId}', this.userInfo.sessionId)
      this.showAnnContent.visible = true
    },
    replaceAll(source, find, replacement) {
      return source.split(find).join(replacement)
    },
    // 关闭系统公告
    closeShowAnnContent() {
      this.showAnnContent.visible = false
      if (this.showAnnContent.isAutoPop) {
        const key = this.$store.getters.tenantId + '_' + this.$store.getters.userId + '_' + this.showAnnContent.releaseVersion
        localStorage.setItem(key, JSON.stringify(this.showAnnContent.chkAuto))
      }
    },
    showTab(jobTypes) {
      // 未配置时，显示全部，配置时，按照配置的显示
      console.info('this.showJobTypes', this.showJobTypes)
      if (!this.showJobTypes || this.showJobTypes.length === 0) {
        return jobTypes
      }
      return jobTypes.filter(item => this.showJobTypes.findIndex(type => type === item.name) > -1)
    },
    onTemplateClick(templateKey) {
      this.fetchNodeInfoByTemplate(templateKey)
    },
    async fetchNodeInfoByTemplate(templateKey) {
      const lob = this.lob
      const data = {
        branchId: this.currentOfficeId,
        lob,
        templateKey
      }
      const loading = getLoading()
      try {
        const res = await getSopNodeInfoByTemplate(data)
        const { jobState, etdStart, etdEnd } = res
        this.sopNodeQuery = {
          jobState,
          etdStart,
          etdEnd
        }
        res.data.sopNodeJobStatistics.forEach((item) => {
          item.copyName = item.name
          item.name = item.name.length > 7 ? item.name.slice(0, 7) + '...' : item.name
        })
        const resdata = {
          templates:
            res.data.templates.map(item => {
              for (const businessType of this.businessTypes) {
                if (businessType.name === lob) {
                  if (businessType.templateNodeCountInfo) {
                    item.nodeCount = businessType.templateNodeCountInfo[item.uuid] || 0
                  }
                  break
                }
              }
              if (item.uuid === templateKey) {
                item.selected = true
              }
              return item
            }).filter(item => item.nodeCount > 0),
          sopNodeJobStatistics:
            res.data.sopNodeJobStatistics.map(item => {
              item.disabled = item.subNodes.every(item1 => {
                return item1.count === '0'
              })
              item.subNodes.forEach((item1) => {
                const subNameLen = item1.subName.length
                item1.subName = subNameLen > 10 ? item1.subName.slice(0, 10) + '...' : item1.subName
              })
              return item
            })
        }
        this.sopNodeData[lob] = resdata
      } finally {
        if (loading) {
          loading.close()
        }
      }
      this.$nextTick(() => {
        this.$refs.sopBoard && this.$refs.sopBoard.__resizeHandler()
      })
      this.measureScrollbar()
    },
    async onTemplateChange(oldTemplateKey, newTemplateKey) {
      const loading = getLoading()
      try {
        await updateTrackingTemplateUuids({ oldTemplateKey, newTemplateKey })
        loading.close()
        setTimeout(() => {
          this.fetchNodeInfo(true)
        })
      } catch {
        loading.close()
      }
    },
    viewMoreLogs() {
      this.$router.push({ name: 'DataUpdateLog' })
    },
    // 加载首页看板tab默认值配置
    // async loadTabPersonConfig() {
    //   try {
    //     // sop 工作任务看板,是否展现
    //     await showSopWtDashBoard().then(async res => {
    //       this.showSopWtDashBoard = res.data
    //     })
    //     // this.loading = getLoading('dashboard-label')
    //     const currentUserInfo = getUserInfo()
    //     const data = {
    //       configModule: '11111',
    //       configName: `local_ui_person_dashboardTab_${currentUserInfo.tenantId}_${currentUserInfo.userId}_11111`,
    //       configType: 3, // 固定值
    //       configBy: currentUserInfo.userId,
    //       tenantId: currentUserInfo.tenantId
    //     }
    //     if (pageCache.activateTab === 'sopWorkTaskBoard' && pageCache.sopWorkTaskBoardLob) {
    //       this.sopWorkTaskBoardLob = pageCache.sopWorkTaskBoardLob
    //       if (!this.showSopWtDashBoard) {
    //         this.activateTab = 'sopBoard'
    //       } else {
    //         this.activateTab = pageCache.activateTab
    //       }
    //     } else if (pageCache.activateTab === 'preWarning' && pageCache.preWarningLob && this.preWarningSettingEnable) {
    //       this.preWarningLob = pageCache.preWarningLob
    //       this.activateTab = pageCache.activateTab
    //     } else {
    //       await getPersonQueryConfig(data).then(res => {
    //         const { data } = res
    //         if (data && data.length > 0) {
    //           const configContent = JSON.parse(data[0].configContent)
    //           this.activateTab = configContent.activateTab
    //           if (configContent.activateTab === 'sopBoard') {
    //             this.lob = configContent.lob
    //             this.activateTab = configContent.activateTab
    //           } else if (configContent.activateTab === 'sopWorkTaskBoard') {
    //             this.sopWorkTaskBoardLob = configContent.lob
    //             // this.$refs.sopWorkTaskBoard.lob = configContent.lob
    //             if (!this.showSopWtDashBoard) {
    //               this.activateTab = 'sopBoard'
    //             } else {
    //               this.activateTab = configContent.activateTab
    //             }
    //           } else if (configContent.activateTab === 'preWarning') {
    //             this.preWarningLob = configContent.lob
    //             this.activateTab = configContent.activateTab
    //             // this.$refs.preWarning.activateTab = configContent.lob.toLowerCase()
    //           }
    //           // console.log('this.activateTab:', this.activateTab)
    //         }
    //         // this.loadData()
    //       }).finally(() => {
    //         // this.loading.close()
    //       })
    //     }
    //   } catch (e) {
    //     // error
    //   }
    // },
    // 加载首页看板tab默认值配置
    async loadTabPersonConfig() {
      await queryModuleListFunc().then(res => {
        this.warningModules = res.data || []
      })
    },
    // 保存首页看板tab默认值配置
    async saveTabPersonConfig() {
      this.loading = getLoading('dashboard-label')
      const currentUserInfo = getUserInfo()
      let lob = null
      if (this.activateTab === 'sopBoard') {
        lob = this.lob
      } else if (this.activateTab === 'sopWorkTaskBoard') {
        lob = this.sopWorkTaskBoardLob
      } else if (this.activateTab === 'preWarning') {
        lob = this.preWarningLob
      }
      const data = {
        configModule: '11111',
        configName: `local_ui_person_dashboardTab_${currentUserInfo.tenantId}_${currentUserInfo.userId}_11111`,
        configType: 3, // 固定值
        configContent: JSON.stringify({ 'activateTab': this.activateTab, 'lob': lob })
      }
      savePersonQueryConfig(data).then(res => {
        this.$message.success(this.$t('Tool.SaveSucceed'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // // 刷新数据
    // loadData() {
    //   this.$refs.sopWorkTaskBoard.refreshPage()
    // },
    // 刷新数据、tab切换
    async loadData(isSync = false) {
      if (this.activateTab === 'sopBoard') {
        this.refreshTime = formatHourMinute(new Date())
        if (isSync) {
          // await this.refreshPage()
          this.refreshTime = formatHourMinute(new Date())
          // await this.sopBoardCount()
          this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
        } else {
          this.refreshPage()
        }
        return
      }
      if (this.activateTab === 'sopWorkTaskBoard') {
        this.sopWorkTaskBoardRefreshTime = formatHourMinute(new Date())
        if (this.$refs.sopWorkTaskBoard) {
          if (isSync) {
            await this.$refs.sopWorkTaskBoard.refreshPage()
            this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
            return
          } else {
            this.$refs.sopWorkTaskBoard.refreshBySetting()
          }
        }
        return
      }
      this.otherRefreshTime = formatHourMinute(new Date())
      if (this.activateTab === 'preWarning') {
        if (this.$refs.preWarning) {
          if (isSync) {
            await this.$refs.preWarning.refreshPage()
            this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
          } else {
            this.$refs.preWarning.refreshBySetting()
          }
        }
        return
      }
      if (this.activateTab === 'approvalMatters') {
        if (this.$refs.approvalMatters) {
          if (isSync) {
            await this.$refs.approvalMatters.fetchData()
            this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
          } else {
            this.$refs.approvalMatters.fetchData()
          }
        }
        return
      }
      if (this.activateTab === 'warningPending') {
        if (this.$refs.warningPending) {
          if (isSync) {
            await this.loadTabPersonConfig()
            await this.$refs.warningPending.refreshPage()
            this.$message.success(this.$t('AutomaticRelease.refreshSuccess'))
          } else {
            this.$refs.warningPending.refreshBySetting()
          }
        }
        return
      }
    },
    setOperationDateQueryData() {
      console.log('主应用发送OperationDateQuery:', this.operationDateQuery)
      microApp.forceSetData('child-operation-date-query-sopboard', this.operationDateQuery)
    },
    operationDateQueryDataChange(e) {
      console.log('主应用获取OperationDateQuery:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateQueryData()
        } else {
          this.operationDateQuerySearch = e.detail.data.searchItem
          this.operationDateQueryColumn = e.detail.data.columnItem
        }
      }
    }
  }
}
</script>

<style lang="scss">
.dashboard-admin-container {
  .el-dialog__body {
    padding: 0 !important;
  }
  background-size: 100% 100%;
  height: 100%;
  padding: 0px 7px 10px 6.5px;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-content: space-between;
  // align-items: center;
}
.refresh-setting {
  position: fixed;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  margin-bottom: 14px;
  align-items: center;
  right: 14px;
  z-index: 99;
}
.entry-container-wrapper {
  //min-height: 146px;
  border-radius: 2px !important;
  padding: 14px 12px !important;
  margin-bottom: 14px !important;
  margin-top: 10px;
  position: relative;
  .pop-content {
    font-size: 12px;
    color: #333;
    line-height: 28px;
  }
  .entry-expand {
    position: absolute;
    right: 10px;
    color: #1F75D5;
    top: 10px;
    & > i {
      font-size: 13px;
      margin-left: 7px;
      cursor: pointer;
    }
  }
  .entry-container-div {
    /*border:5px solid rgba(155, 221, 255, 0.17);*/
    /*border-radius: 5px;*/
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    text-align: center;

    .entry-div:hover {
      // background-color: rgba(238, 238, 238, 0.57);
      cursor: pointer;
    }
    .entry-div {
      position: relative;
      width: 64px;
      height: 64px;
      display: flex;
      background-color: #1f75d5;
      border-radius: 10px;
      text-align: center;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-around;
      margin: 10px 5px;

      .notice-unread {
        font-size: 16px;
        font-weight: 700;
        position: absolute;
        top: -15px;
        right: -10px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        color: #fff;
        background: red;
      }
    }
  }
}
.sidebar {
  margin-left: 159px;
}
.layer_height {
  height: 300px;
}
.sopWrapper {
  margin-bottom: 14px !important;
  padding: 0px 0px 0px 20px !important;
  position:relative;
}
.preWarning-wrapper {
  padding: 14px 11px 5px !important;
  margin-bottom: 14px !important
}
</style>

<style lang="scss" scoped>
.details-view{
  .main-content{
    .tip{
      display: flex;
      flex-display: row;
      justify-content: space-between;
      align-items: center;
      .el-carousel{
        width: 85% !important;
        line-height: 30px;
        background-color: #F6F3E9FF;
        .el-carousel__item{
          padding-left: 20px;
        }
      }
    }
  }

  .owe-remind-dialog {
    .el-dialog__header {
      margin: 0px;
      margin-top: -1px;
      padding: 0px;
    }
    .owe-remind {
      background-size: cover;
      background-repeat: no-repeat;
      min-height: 160px;
      padding: 40px 20px 80px 20px;
      font-size: 20px;
      font-weight: lighter;
      line-height: 24px !important;
      color: #FFF !important;
      /deep/ p{
        margin: 0;
        padding: 0;
        font-size: 20px;
        color: #FFF;
      }
    }
  }
  .dialog-anncontent{
    /deep/ .el-textarea {
      font{
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif !important;
        font-size: 12px !important;
      }
    }
  }
}
</style>
